import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { setAuthToken, setUserData } from "./authUtils";
import { backendScope } from "../authConfig";


const AuthWatcher = () => {
  const { accounts, inProgress, instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  const setUser = (accountDetails) => {
    const username = accountDetails.username;
    const firstname = accountDetails.name.split(' ')[0];
    const lastname = accountDetails.name.split(' ')[1];
    const data = {
      username,
      firstname,
      lastname
    }

    setUserData(data);
  }

 useEffect(() => {
  const getToken = async () => {
    if (inProgress === "none" && accounts.length > 0) {
      try {
        const response = await instance.acquireTokenSilent({
          scopes: backendScope,
          account: accounts[0],
        });

        if (response.accessToken) {
          setAuthToken(`Bearer ${response.accessToken}`);
        }

        setUser(accounts[0]);

      } catch (error) {
        console.error("Token error:", error);
      }
    }
  };

  getToken();
}, [accounts, inProgress, instance]);  


  useEffect(() => {
    if (
      inProgress === "none" &&
      accounts.length > 0 &&
      location.pathname.endsWith('/login')
    ) {
      instance.setActiveAccount(accounts[0]);
      navigate("/agent-studio-ai", { replace: true });
    }
  }, [accounts, inProgress, location.pathname, navigate, instance]);

  return null;
};

export default AuthWatcher;
